import React, { useState, useCallback, useRef, useEffect } from "react";
import Arrow from "./Arrow";
import "./GlobalUI.css";
import { Loader } from "./Loader/index";
import Scene3d from "../Scene3d/Scene3d";

const scenes = [
    {
        id: 1,
        title: "Branding",
        image: "1.jpg",
        btnimage: "Branding.png",
        backgroundColor: "#219C90",
        circleColor: "#EE4E4E",
        titlecolor: "#FFF455",
        arrowColor: "#FFC700",
    },
    {
        id: 2,
        title: "Web Development",
        image: "2.jpg",
        btnimage: "webdvlpmt.png",
        backgroundColor: "#B4D6CD",
        circleColor: "#FF4E88",
        titlecolor: "#FFDA76",
        arrowColor: "#FF8C9E",
    },
    {
        id: 3,
        title: "Social Media Management ",
        image: "3.jpg",
        btnimage: "SM Management.png",
        backgroundColor: "#F9DBBA",
        circleColor: "#1A4870",
        titlecolor: "#1F316F",
        arrowColor: "#5B99C2",
    },
    {
        id: 4,
        title: "3D Visualization",
        image: "4.jpg",
        btnimage: "3D visualisation.png",
        backgroundColor: "#FF8343",
        circleColor: "#4158A6",
        titlecolor: "#F1DEC6",
        arrowColor: "#179BAE",
    },
    {
        id: 5,
        title: "Search Engine Optimization",
        image: "5.jpg",
        btnimage: "SEO.png",
        backgroundColor: "#A02334",
        circleColor: "#96CEB4",
        titlecolor: "#FFAD60",
        arrowColor: "#FFEEAD",
    },
    {
        id: 6,
        title: "Digital Ads Management",
        image: "6.jpg",
        btnimage: "Digital ads management.png",
        backgroundColor: "#36BA98",
        circleColor: "#E76F51",
        titlecolor: "#E9C46A",
        arrowColor: "#F4A261",
    },
];
const GlobalUI = () => {
    const [isLoadingVisible, setisLoadingVisible] = useState(true);
    const [currentScene, setCurrentScene] = useState(0);
    const [nextScene, setNextScene] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [overlayState, setOverlayState] = useState(""); // '', 'expanding', or 'contracting'
    const timeoutRef = useRef(null);

    const navigate = useCallback(
        (direction) => {
            if (isTransitioning) return;

            setIsTransitioning(true);
            const next = (currentScene + direction + scenes.length) % scenes.length;
            setNextScene(next);
            setOverlayState("expanding");

            // Trigger 3D model change
            if (direction === 1) {
                nextModel();
            } else {
                previousModel();
            }

            timeoutRef.current = setTimeout(() => {
                setOverlayState("contracting");
                setCurrentScene(next);

                timeoutRef.current = setTimeout(() => {
                    setOverlayState("");
                    setIsTransitioning(false);
                }, 500);
            }, 500);
        },
        [currentScene, isTransitioning]
    );

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    useEffect(() => {
        const adjustViewportHeight = () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        adjustViewportHeight();

        window.addEventListener('resize', adjustViewportHeight);
        window.addEventListener('orientationchange', adjustViewportHeight);

        return () => {
            window.removeEventListener('resize', adjustViewportHeight);
            window.removeEventListener('orientationchange', adjustViewportHeight);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const { backgroundColor, circleColor, title, titlecolor, arrowColor } =
        scenes[currentScene];
    const nextCircleColor = scenes[nextScene].circleColor;

    const nextModel = () => {
        const event = new CustomEvent("next-model");
        window.dispatchEvent(event);
    };
    const previousModel = () => {
        const event = new CustomEvent("previous-model");
        window.dispatchEvent(event);
    };

    return (//style={{ backgroundColor }}
        <div className="GlobalUIContainer" >
            <Loader isLoading={isLoadingVisible} />
            <div className="SceneDiv">
                <Scene3d
                    currentScene={currentScene}
                    setCurrentScene={setCurrentScene}
                    nextScene={nextScene}
                    setNextScene={setNextScene}
                    isTransitioning={isTransitioning}
                    setisLoadingVisible={setisLoadingVisible}
                />
            </div>
            {/* circleColor */}
            <div className="circle" style={{ backgroundColor: '#F26524' }}></div>
            {/* <div
                className={`overlay ${overlayState}`}
                style={{ backgroundColor: nextCircleColor }}
            ></div> */}
            <div className={`titlecontent ${isTransitioning ? "transitioning" : ""}`}>

                {/* titlecolor */}
                <div className="title" style={{ color: 'rgb(255,255,255)' }}>
                    {title}
                </div>
            </div>
            <button
                className={`nav-button left ${isTransitioning ? "disabled" : ""}`}
                onClick={() => !isTransitioning && navigate(-1)}
                disabled={isTransitioning}
            >
                <Arrow direction="left" color={'#ffffff'} />
            </button>
            <button
                className={`nav-button right ${isTransitioning ? "disabled" : ""}`}
                onClick={() => !isTransitioning && navigate(1)}
                disabled={isTransitioning}
            >
                {/* color={isTransitioning ? "white" : arrowColor} */}
                <Arrow direction="right" color={'#ffffff'} />
            </button>
            {/* <button className="Discover-btn">
                <img
                    src={scenes[currentScene].btnimage}
                    alt={scenes[currentScene].title}
                />
            </button> */}
        </div>
    );
};

export default GlobalUI;